import { Component, Input, OnInit } from '@angular/core'
import { Persona } from 'se-resource-types/dist/lib/UserService'
import { environment } from '@se-po/shared-environments'

@Component({
  selector: 'se-po-profile-bar',
  templateUrl: './profile-bar.component.html',
  styleUrls: ['./profile-bar.component.scss'],
  standalone: false,
})
export class ProfileBarComponent implements OnInit {
  @Input() public selfPersona: Persona

  public avatarIcon: string
  public seIcon: string

  public ngOnInit(): void {
    this.avatarIcon = this.avatarIconUrl()
    this.seIcon = `${environment.uiThemes}/assets/latest/images/se-logos/se-icon.svg`
  }

  private avatarIconUrl(): string {
    const croppedImage = this.selfPersona.profile_images?.find(i => i.image_type === 'crop_icon')
    if (croppedImage && croppedImage.url) {
      return croppedImage.url
    }
    const originalImage = this.selfPersona.profile_images?.find(i => i.image_type === 'original')
    return originalImage && originalImage.url ? originalImage.url : ''
  }
}
